import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  locales: ['it', 'en', 'es', 'zh'],
  defaultLocale: 'it',
  localePrefix: {
    mode: "as-needed",
  }
});

export const locales: readonly string[] = routing.locales;

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter, permanentRedirect, getPathname } =
  createNavigation(routing);

// Can be used in single pages to generate static paths for SSG
export function generateStaticParams() {
  return routing.locales.map((locale) => ({ locale }));
}
